const constants = {
  SET_AFFILIATE: "SET_AFFILIATE",
  SET_ARRIVAL: "SET_ARRIVAL",
  SET_ARRIVAL_TIMES: "SET_ARRIVAL_TIMES",
  SET_COMPLETED: "SET_COMPLETED",
  SET_COUNTRY_CODE: "SET_COUNTRY_CODE",
  SET_ENVIRONMENT: "SET_ENVIRONMENT",
  SET_GUEST_TYPE: "SET_GUEST_TYPE",
  SET_LOCAL_PROFILE_ELEMENTS: "SET_LOCAL_PROFILE_ELEMENTS",
  SET_MARKETING_REFERRERS: "SET_MARKETING_REFERRERS",
  SET_PICKUP: "SET_PICKUP",
  SET_PRODUCTS: "SET_PRODUCTS",
  SET_PRODUCT: "SET_PRODUCT",
  SET_REFERRAL: "SET_REFERRAL",
  SET_REGISTERED: "SET_REGISTERED",
  SET_USER: "SET_USER",
  SET_GUEST_KIND: "SET_GUEST_KIND",
  SET_GUEST_KIND_UNKNOWN_PLACE: "SET_GUEST_KIND_UNKNOWN_PLACE",
  SET_VACCINATION_OPTIONS: "SET_VACCINATION_OPTIONS",
  SET_VACCINATION_INFO: "SET_VACCINATION_INFO",
  SET_ONSHORE: "SET_ONSHORE",
  SET_DEPARTURE: "SET_DEPARTURE",
  SET_DEPARTURE_PICKUP: "SET_DEPARTURE_PICKUP",
  SET_UPLOAD_STATUS: "SET_UPLOAD_STATUS",
  SET_UPLOAD_PROGRESS: "SET_UPLOAD_PROGRESS",
  RESET_UPLOAD: "RESET_UPLOAD"
};

export default constants;
